<p-confirmDialog key="main" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>
<p-confirmDialog key="mainDelete" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Menu Bar-->
<div class="lock-to-top" style="background-color: #ffffff">
	<!--School Select-->
	<div class="selector-body">
		<div class="selector-item">
			<div>
				<label>School</label>
			</div>

			<div style="margin-left: 10px">
				<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
				<!-- <select class="form-control" name="SchoolSelector" style="font-size:smaller;"
					[(ngModel)]="SelectedSchoolID"
					(ngModelChange)="onSchoolChange($event)">
					<option *ngFor="let r of lstSchool" [ngValue]="r.SchoolID">[{{r.SchoolNumber}}] {{r.SchoolName}}</option>
				</select> -->

				<caass-schoolselector [ShowAll]="false" [Disabled]="loading"> </caass-schoolselector>
			</div>
		</div>
	</div>

	<!--Buttons-->
	<div class="button-body flex">
		<button [disabled]="loading" class="btn btn-primary" style="margin-left: 0px" (click)="onRefresh()">Refresh</button>

		<button [disabled]="loading" class="btn btn-primary" style="margin-left: 5px" (click)="onAdd()">Add Group</button>
		<button [disabled]="loading" class="btn btn-primary" style="margin-left: 5px" (click)="onEdit()">Edit Group</button>
		<button [disabled]="loading" class="btn btn-primary" style="margin-left: 5px" (click)="onImport()">Import Groups</button>
		<button [disabled]="loading" class="btn btn-primary" style="margin-left: 5px" (click)="onToggle()">
			{{ ToggleText }}
		</button>
		<button [disabled]="loading" class="btn btn-primary" style="margin-left: 5px" (click)="onDelete()">Delete Group</button>
	</div>
</div>

<!--Table-->
<div class="table-main-body">
	<p-table
		#mydt
		[value]="lstStudentGroups"
		[loading]="loading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedStudentGroup"
		dataKey="GroupID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<th>
					<p-columnFilter type="text" field="GroupName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>
				<th>
					<p-columnFilter name="SCount" type="numeric" field="StudentCount" [showMenu]="true"></p-columnFilter>
				</th>
				<th>
					<p-columnFilter name="ACount" type="numeric" field="ActionCount" [showMenu]="true"></p-columnFilter>
				</th>
				<th></th>
				<th>
					<p-columnFilter field="Active" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								name="filterActive"
								#filterActive
								[ngModel]="value"
								[options]="lstActive"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<th pSortableColumn="GroupName">Group Name<p-sortIcon field="GroupName"></p-sortIcon></th>
				<th pSortableColumn="StudentCount">Student Count<p-sortIcon field="StudentCount"></p-sortIcon></th>
				<th pSortableColumn="ActionCount">Actions Count<p-sortIcon field="ActionCount"></p-sortIcon></th>
				<th pSortableColumn="UpdateDate">Last Update<p-sortIcon field="UpdateDate"></p-sortIcon></th>
				<th pSortableColumn="Active">Active<p-sortIcon field="Active"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-studentgroup>
			<tr [pSelectableRow]="studentgroup" (dblclick)="onRowDblClick(studentgroup)">
				<td *ngFor="let col of cols" style="font-weight: bold">
					{{ studentgroup[col.field] }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<!--Error Message-->
<div class="form-group groups-TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
